import React from "react";
import RetailSalesReportGenericSkeleton from "./RetailSalesReportGenericSkeleton";

function RetailSalesReportDetailSkeleton() {
  return (
    <>
      <RetailSalesReportGenericSkeleton />
    </>
  );
}

export default RetailSalesReportDetailSkeleton;
